import { BarChartData } from '../types/BarChart.types';

export const normalizeData = (data: BarChartData[]) => {
  if (!data.length) return Array(4).fill({ value: null });

  const topEdgeOffset = 0 / 100;
  const maxValue = data.reduce((acc, item) => {
    if (item.value > acc) acc = item.value;

    return acc;
  }, 0);

  return data.map((item) => ({ ...item, normalizedValue: 100 * (item.value / maxValue - topEdgeOffset) }));
};
